/**
 * 
 */
(function() {
	"use strict";
	angular.module("cbl.finanza.mf").directive(
			"finFuna",
			[
					'FinFunaSrvc',
					'FinLabelSrvc',
					'FinLoggerSrvc',
					'FIN_CONSTANTS',
					function(funaSrvc, labelSrvc, loggerSrvc, CONSTANTS) {
						var link = function(scope, elem, attrs, ctrl) {

						};

						var controller = function($scope) {
							$scope.funa = funaSrvc;
							$scope.msg = labelSrvc;
							$scope.getKey = function(funa) {
								return "funa.label." + funa.codice;
							};
						};

						controller.$inject = [ "$scope" ];

						return {
							restrict : "E",
							scope : {
								rightAlign : "=",
								finDisabled : "=?"
							},
							link : link,
							transclude : true,
							controller : controller,
							templateUrl : CONSTANTS.BASE_ROOT + "widgets/finFuna/finFuna.html"
						};
					} ]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finFuna/finFunaDrct.js
 ** module id = 6
 ** module chunks = 0 1 2
 **/